import * as React from "react";

import { cn } from "@/lib/utils";

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          /* input do sistema: raio 10 (`rounded-sm` resolve para 10px), contorno na
             hairline-strong — a fina some sobre papel — e superfície elevada,
             não o fundo da página.

             ⚠️ FOCO SEM MARCA NENHUMA, e o caminho até aqui tem uma lição.
             Eram `ring-2` + `ring-offset-2`: um segundo traço flutuando FORA
             da caixa, que ✅ Pedro mandou tirar em 21/08 junto com o laranja.

             Tentei primeiro trocar por `focus-visible:border-foreground`,
             raciocinando que `focus-visible` só dispara na navegação por
             teclado e portanto ninguém no dedo veria. ERRADO, e a medição
             pegou: em `<input>` de TEXTO o `:focus-visible` casa em qualquer
             foco, inclusive toque — a spec trata assim justamente porque o
             campo recebe teclado. Medido: um clique simples já escurecia a
             borda para #1A1713.

             Então não há marca de foco, e o que segura a acessibilidade é o
             CURSOR: campo de texto focado pisca o caret, que é indicador de
             foco nativo e não desenhado por nós. Isto vale para input de
             texto; botão e link, que não têm caret, MANTÊM o anel. */
          "flex h-10 w-full rounded-sm border border-border-strong bg-card px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
